import { render, staticRenderFns } from "./Unknown.vue?vue&type=template&id=076a49a2&scoped=true&"
import script from "./Unknown.vue?vue&type=script&lang=js&"
export * from "./Unknown.vue?vue&type=script&lang=js&"
import style0 from "./Unknown.vue?vue&type=style&index=0&id=076a49a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076a49a2",
  null
  
)

export default component.exports